import createEnum from 'scripts/lib/create_enum';

const CompositionContentType = createEnum(
  'CHAT',
  'COBROWSE_WIDGET',
  'CONVERSATION_MESSAGE',
  'CONVERSATION_NOTE',
  'CONVERSATION',
  'CREDIT_CARD_REQUEST',
  'CUSTOM_CHANNEL',
  'EMAIL',
  'EXTERNAL_FORM',
  'FB_MESSAGE',
  'PHONE_CALL',
  'PHONE_CALLBACK',
  'SMS',
  'TASK_EDIT',
  'TASK_THREAD_REPLY',
  'TASK',
  'THIRD_PARTY_EMAIL',
  'TWITTER'
);

export default CompositionContentType;
